document.addEventListener("DOMContentLoaded", function () {

  /* -------------------------------
     MOBILE NAV
  --------------------------------*/
  const toggleButton = document.querySelector('[data-action="toggle-nav"]');
  const navSections = document.querySelector('.nav-sections');
  const closeButton = document.querySelector('.close-nav-button');

  if (toggleButton && navSections) {
    toggleButton.addEventListener('click', function () {
      navSections.classList.toggle('open');
      document.body.classList.toggle('nav-open');
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      navSections.classList.remove('open');
      document.body.classList.remove('nav-open');
    });
  }

  document.querySelectorAll('.nav-toggle-arrow').forEach(arrow => {
    arrow.addEventListener('click', function () {
      const parent = this.closest('.parent');
      parent.classList.toggle('open');
    });
  });



  /* -------------------------------
     SEARCH TOGGLE
  --------------------------------*/
  const toggle = document.querySelector('.search-toggle');
  const siteSearch = document.querySelector('.site-search');
  const searchInput = siteSearch?.querySelector('input');

  if (toggle && siteSearch) {
    toggle.addEventListener('click', () => {
      siteSearch.classList.toggle('expanded');
      siteSearch.classList.toggle('collapsed');

      if (siteSearch.classList.contains('expanded')) {
        searchInput?.focus();
      }
    });
  }



  /* -------------------------------
     PREDICTIVE SEARCH
  --------------------------------*/
  const form = document.querySelector('[data-predictive-search]');
  const input = form?.querySelector('input[name="q"]');
  const resultsBox = document.querySelector('.predictive-search-results');

  let controller = null;

  if (form && input && resultsBox) {
    input.addEventListener('input', async function () {
      const query = this.value.trim();

      if (!query) {
        resultsBox.innerHTML = '';
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`,
        { signal: controller.signal }
      );

      const data = await res.json();
      const products = data.resources.results.products;

      if (products.length === 0) {
        resultsBox.innerHTML = '<p>No results</p>';
        return;
      }

      resultsBox.innerHTML = `
        <ul class="predictive-list">
          ${products.map(p => `
            <li><a href="${p.url}">${p.title}</a></li>
          `).join('')}
        </ul>
      `;
    });
  }



  /* -------------------------------
     CLICK OUTSIDE → CLOSE RESULTS
  --------------------------------*/
  document.addEventListener("click", function (e) {
    if (!form || !resultsBox || !siteSearch) return;
  
    const clickedOutsideForm = !form.contains(e.target);
    const clickedOutsideResults = !resultsBox.contains(e.target);
  
    if (clickedOutsideForm && clickedOutsideResults) {
      // Clear predictive results
      resultsBox.innerHTML = '';
  
      // Collapse search bar
      siteSearch.classList.remove('expanded');
      siteSearch.classList.add('collapsed');
    }
  });
  

});
